<div class="container-fluid px-0 pt-5 pb-3 pb-md-2 background-bg">
  <div class="container d-flex w-100 mx-auto pt-3 pt-md-5">
    <div class="d-flex col-12 col-md-12 justify-content-center">
      <app-user-access-form *appShellNoRender [enabled]="enabled" [params]="params" (onCloseForm)="enabled= false" [isModalDisplay]="isModalDisplay" [isMainLogin]="isMainLogin"></app-user-access-form>
    </div>
  </div>
</div>
